// extracted by mini-css-extract-plugin
export default {"container":"styles_container__BeRD6","green_btn":"styles_green_btn__o0mHM","success_img":"styles_success_img__K4T9K"};